module.exports = __webpack_public_path__ + "img/online-shopping-laptop.f8e1ca1c.svg";